import type { ModuleSpecField } from './specTypes';

/** Kept aligned with ModuleSpecOwnershipRules.validateCreateKey. */
export function canUseCreateKey(field: ModuleSpecField): boolean {
  return !['id', 'uuid', 'tenant_id', 'workspace_id', 'owner_user_id', 'created_at', 'updated_at'].includes(field.name)
    && !field.computed && ['text', 'number', 'select', 'date', 'typeahead'].includes(field.type)
    && !Object.prototype.hasOwnProperty.call(field.protection ?? {}, 'tokenize');
}
